module.exports = __webpack_public_path__ + "img/item7.c75566b5.png";